import React from 'react'
import './style.css'
import HomeFull from './HomeFull'
import HomeMobile from './HomeMobile'

const Home = (props) => {
	
	return(
    
        <React.Fragment>

            { props.isMobile ? <HomeMobile /> : <HomeFull /> }
		
        </React.Fragment>
		
    )

}

export default Home


 


// WEBPACK FOOTER //
// ./src/components/home/index.js